import { render, staticRenderFns } from "./information-snackbar.vue?vue&type=template&id=09f2d868&scoped=true&lang=pug"
import script from "./information-snackbar.vue?vue&type=script&lang=js"
export * from "./information-snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f2d868",
  null
  
)

export default component.exports